import { message } from 'antd';
import * as R from 'ramda';
import axios from 'axios';
import uniqid from 'uniqid';
import { cancelled, all, select, fork, cancel, race, call, put, take, takeEvery, takeLatest } from 'redux-saga/effects';
import { push, replace } from 'redux-little-router';
import dbTabsSagas from '../db/dbTabsSagas';
import queriesAPI from '../../api/queriesAPI';
import { defineQuery } from '../../reducers/queryReducer';
import entityActions from '../../genericActions/entityActions';

const runVBQLQueryProcess = function* (action) {
  const connection = yield select(store => (
    store.connection.byId[store.connection['/window'].ids[0]]
  ));

  let result;
  try {
    result = yield call(
      queriesAPI.postQuery,
      connection,
      action.payload.query,
    );
  } catch (err) {
    message.error('Error running query.');
    yield put(entityActions.receiveErrors(
      action.payload.keyWindow,
      { queryResults: R.pathOr([], ['response', 'data', 'errors'], err) },
    ));
  }

  yield call(
    dbTabsSagas.updateQuerySaga,
    connection.id,
    parseInt(action.payload.keyWindow.split('/').pop(), 10),
    action.payload.query,
  );

  if (result) {
    const queryResults = { id: action.payload.keyWindow, ...result };
    yield put(entityActions.receiveEntities(
      action.payload.keyWindow,
      {
        type: 'queryResults',
        byId: { [queryResults.id]: queryResults },
        ids: [queryResults.id],
      },
      {
        type: 'queries',
        byId: { [action.payload.query.id]: action.payload.query },
        ids: [action.payload.query.id],
      },
    ));
    return queryResults;
  }
  return undefined;
};

const renameQuerySaga = function* (action) {
  const { id: connectionId, bearerToken, betaApiKey } = yield select(store => (
    store.connection.byId[store.connection['/window'].ids[0]]
  ));
  const queryResults = yield select(store => (
    store.queryResults.byId[action.payload.keywindow]
  ));

  yield call(
    dbTabsSagas.updateQuerySaga,
    connectionId,
    parseInt(action.payload.keyWindow.split('/').pop(), 10),
    action.payload.query,
  );
  yield put(entityActions.receiveEntities(
    action.payload.keyWindow,
    {
      type: 'queries',
      byId: { [action.payload.query.id]: action.payload.query },
      ids: [action.payload.query.id],
    },
    queryResults
      ? {
        type: 'queryResults',
        byId: { [queryResults.id]: queryResults },
        ids: [action.payload.queryResults.id],
      } : {
        type: 'queryResults',
        byId: {},
        ids: [],
      },
  ));
};

const queryTabProcess = function* (tabId) {
  try {
    const tab = yield select(store => store.tab.byId[tabId]);
    const tabQuery = tab.query;

    yield put(defineQuery(
      `/tab/${tabId}`,
      tabQuery.id,
      { ...tabQuery },
    ));

    yield put(entityActions.receiveEntities(
      `/tab/${tabId}`,
      {
        type: 'queries',
        byId: { [tabQuery.id]: tabQuery },
        ids: [tabQuery.id],
      },
    ));

    while (true) {
      const { run, rename } = yield race({
        run: take(
          action => (
            action.type === 'FETCH_QUERY_RESULTS' &&
            action.payload &&
            action.payload.keyWindow === `/tab/${tabId}`
          ),
        ),
        rename: take(
          action => (
            action.type === 'RENAME_QUERY' &&
            action.payload &&
            action.payload.keyWindow === `/tab/${tabId}`
          ),
        ),
      });

      if (run) {
        yield call(runVBQLQueryProcess, run);
      } else if (rename) {
        yield call(renameQuerySaga, rename);
      }
    }
  } finally {
    if (yield cancelled()) {
      yield put(entityActions.releaseKeyWindow(`/tab/${tabId}`));
    }
  }
};

export default queryTabProcess;
